import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Steps from "../../Steps";
import Button from "../../../../common/Button";
import { Link, useParams } from "react-router-dom";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import {
  updateMinorAilmentStatus,
  updateClinicalService,
  updateMedicationReview,
  updateMedicalReviewStatus,
  updateMedication,
} from "../../../../../redux/modules/clinical-services/actions";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ReactSVG } from "react-svg";
import {
  ClinicalServiceTypes,
  getValidStep,
} from "../../../text/data";
import { drugTypes } from "../clinical-assessment/data";
import { getTreatmentDrugs } from "../treatment/data";
import PdfDialog from "../../../../common/pdf-viewer/PdfDialog";
import OldPdfDialog from "../../../../common/pdf-viewer/OldPdfDialog";
import {
  AllergicRhinitisDocTypes,
  DocumentTitles,
  PrimaryProviderRuleTooltipsSelected,
  PrimaryProviderRuleTooltipsDisabled,
  AllergicRhinitisForms,
  checkAMRFormEnable,
  checkFormEnable,
  GetReferralDetails,
  ListOfAMRForms,
  ListOfForms,
  MedicationReviewDocTypes,
  MedicationReviewForms,
} from "./data";
import NewToolTip from "../../../../common/New-ToolTip";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import { InitialAssessmentForm } from "../../../../pdf-forms/initial-assessment-form-oldform";
import { PhysicianReferralForm } from "../../../../pdf-forms/physician-referral-form-oldform";
import SubNavigation from "../../common/sub-navigation";
import { hasUnresolvedFollowUpInterventions } from "../../../../../helpers/functions";

const Documentations = () => {
  const { clinicalServiceObj, clinicalServiceName, clinicalServiceSteps } =
    useSelector((state) => state.clinicalService);
  const { patient } = useSelector((state) => state.patients);
  const dispatch = useDispatch();
  const { serviceId, id } = useParams();
  const navigate = useNavigate();
  const { currentStep, currentSubStep, documentation, startDateTime } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [filePath, setFilePath] = useState("");
  const [pdfTitle, setPdfTitle] = useState("");
  const [showPdfViewer, setShowPdfViewer] = useState(false);
  const [allForms, setAllForms] = useState([]);
  const [pageTitle, setPageTitle] = useState(null);
  const [openServiceCompleteDialog, setOpenServiceCompleteDialog] =
    useState(false);
  const [formType, setFormType] = useState(null);
  const [image, setImage] = useState(null);
  const [formComponent, setFormComponent] = useState(null);
  const { showReferral } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [showRef, setShowRef] = useState(showReferral ?? false);
  const [noInterventionConfirmation, setNoInterventionConfirmation] =
    useState(null);
  const assessmentForm =
    clinicalServiceObj?.initialAssessment?.initialAssessmentForm || {};
  const completedMedicationUpdate =
    assessmentForm?.documentation?.completeMedicationUpdate === true;
  const isPmrInReview =
    clinicalServiceName === ClinicalServiceTypes.MedicationReview &&
    !completedMedicationUpdate &&
    hasUnresolvedFollowUpInterventions(assessmentForm?.medications);

  const setDocumentationForms = () => {
    const serviceForms =
      clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis
        ? AllergicRhinitisForms
        : MedicationReviewForms;
    const availableForms =
      clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis
        ? ListOfForms
        : ListOfAMRForms;

    const alertData =
      clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis
        ? GetReferralDetails(
            clinicalServiceObj?.initialAssessment?.initialAssessmentForm
          )
        : null;

    const treatment =
      clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
    const prescriptionDrugs = getTreatmentDrugs(treatment);
    const documentationData = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.documentation;
    
    // Get the "Storyboard" form
    const forms = serviceForms.map((section) => {
      const forms = availableForms
        .filter((form) => form.sectionKey === section.title)
        .map((form, index) => ({
          ...form,
          id: index + 1,
          enable:
            clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis
              ? checkFormEnable(form.type, alertData, prescriptionDrugs, patient?.dateOfBirth, documentationData)
              : checkAMRFormEnable(form.type, noInterventionConfirmation),
        }));

      return { ...section, forms };
    });
    setAllForms(forms);
  };

  useEffect(() => {
    setDocumentationForms();
    // noInterventionConfirmation is saved in documentations-checklist.jsx when user clicks "Complete"
    // No need to auto-save here as it would cause redundant API calls
  }, [noInterventionConfirmation]);

  useEffect(() => {
    if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
      setDocumentationForms();
      setPageTitle("Documentation Forms");
    } else if (clinicalServiceName === ClinicalServiceTypes.MedicationReview) {
      setDocumentationForms();
      setPageTitle("Documentation Forms");
      setNoInterventionConfirmation(
        clinicalServiceObj?.initialAssessment?.initialAssessmentForm
          ?.documentation?.noInterventionConfirmation === "yes"
      );
    }
  }, [clinicalServiceName, clinicalServiceObj]);

  const onPrevious = () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      -1
    );
    const updatedSteps = {
      currentStep: nextStep,
      currentSubStep: nextSubStep,
      showReferral: showRef,
    };
    if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
      dispatch(updateClinicalService(serviceId, updatedSteps));
    } else if (clinicalServiceName === ClinicalServiceTypes.MedicationReview) {
      dispatch(updateMedicationReview(serviceId, updatedSteps));
    }
  };


  // Function to update treatment drugs from PrescribedRx to HistoryPrescribedRx
  const updateTreatmentDrugsToHistory = async () => {
    try {
      const treatment = clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
      if (!treatment) return;

      // Get all treatment drugs
      const prescribedRxDrugs = getTreatmentDrugs(treatment);
      
      if (prescribedRxDrugs.length > 0) {
        // Update each drug from PrescribedRx to HistoryPrescribedRx
        const updatedDrugs = prescribedRxDrugs.map(drug => ({
          ...drug,
          medicationType: drugTypes.HistoryPrescribedRx
        }));

        // Update medications in the backend
        await dispatch(updateMedication(clinicalServiceObj.patientId, {
          medications: updatedDrugs
        }));
      }
    } catch (error) {
      console.error('Error updating treatment drugs to history:', error);
    }
  };

  const onSubmit = async () => {
    if (clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis) {
      // Update treatment drugs from PrescribedRx to HistoryPrescribedRx before completing service
      await updateTreatmentDrugsToHistory();
      await dispatch(
        updateMinorAilmentStatus(
          clinicalServiceObj.id,
          "refer",
          documentation?.billingInformation
        )
      );
    } else if (clinicalServiceName === ClinicalServiceTypes.MedicationReview) {
      await dispatch(updateMedicalReviewStatus(clinicalServiceObj.id, "refer"));
    }
    navigate(`/patient/${clinicalServiceObj.patientId}/clinical-services/`);
  };

  const openFile = (path, title, type) => {
    if (type) {
      setFilePath(path);
      setPdfTitle(title);
      setShowPdfViewer(true);
      setFormType(type);
      document.body.style.overflow = "hidden";
    } else setShowPdfViewer(false);
  };

  const handlePdfRender = () => {
    switch (formType) {
      case AllergicRhinitisDocTypes.initialAssessment:
        return (
          <InitialAssessmentForm
            patient={patient}
            initialAssessmentForm={
              clinicalServiceObj.initialAssessment.initialAssessmentForm
            }
          />
        );
        break;
      case AllergicRhinitisDocTypes.PhysicianReferralForm:
        return (
          <PhysicianReferralForm
            patient={patient}
            initialAssessmentForm={
              clinicalServiceObj.initialAssessment.initialAssessmentForm
            }
          />
        );
      default:
        return (
          <InitialAssessmentForm
            patient={patient}
            initialAssessmentForm={
              clinicalServiceObj.initialAssessment.initialAssessmentForm
            }
          />
        );
        break;
    }
  };

  const ImageModal = ({ image, setImage }) => {
    return (
      image && (
        <div className="fixed inset-0 z-[100] bg-black/50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg relative">
            <Zoom>
              <img src={image} className="max-w-[500px]" alt="Zoomable" />
            </Zoom>
            <button
              type="button"
              className="absolute flex items-center justify-center p-1 transition-all rounded-full max-w-8 cursor-pointer right-4 top-3 bg-blue-200 hover:bg-teal-300 hover:text-white text-teal-300"
              onClick={() => setImage(null)}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon className="w-4 h-4" aria-hidden="true" />
            </button>
          </div>
        </div>
      )
    );
  };

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications />
          <div className="flex flex-1 w-full h-[668px] overflow-y-auto scroll-smooth ">
            <div className="w-full gap-5">
              <div className="flex items-center justify-between mt-2.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  {pageTitle}
                </h4>

                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div className="flex flex-col ">
                <div className="flex flex-row gap-6">
                  {allForms?.map((section, sectionIndex) => (
                    <div key={section.title || sectionIndex} className="h-[585px] w-[564px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                      <div className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center bg-gray-20 border-b-[3px] border-gray-100">
                        <ReactSVG
                          src={section.iconUrl}
                          className={`w-6 pr-14`}
                        />
                        <h3 className="text-xl font-bold text-teal-600">
                          {section.title}
                        </h3>
                      </div>
                      <div className="w-full">
                        {section.forms.map((form, formIndex) => {
                          const tooltipId = `${section.title || sectionIndex}_${form.id || form.type}`;
                          const isStoryboard = form.name === "Storyboard";
                          const isLastForm = formIndex === section.forms.length - 1;
                          const isPersonalMedRecord = form.type === MedicationReviewDocTypes.PersonalMedRecord;
                          const isPatientSection = section.title === DocumentTitles.PatientForms;
                          const isDisabledPersonalMedRecord = isPersonalMedRecord && isPatientSection && isPmrInReview;
                          
                          return (
                            <React.Fragment key={form.id || form.type}>
                              <button
                                className={`flex flex-row w-full gap-2 text-lg text-black py-6 px-6 ${
                                  (form.filePath || form?.clickToOpenImage) &&
                                  "font-semibold"
                                }  ${
                                  form?.enable
                                    ? "bg-teal-25"
                                    : "cursor-default"
                                }`}
                                data-tooltip-id={((form.isTooltip && isStoryboard) || isDisabledPersonalMedRecord) ? tooltipId : undefined}
                                onClick={() => {
                                  if (isDisabledPersonalMedRecord) return;
                                  if (!form.enable) return;
                                  if (form?.clickToOpenImage) {
                                    setImage(form?.imagePath);
                                  } else if (form?.filePath) {
                                    openFile(form.filePath, form.name, form.type);
                                  } else {
                                    navigate(
                                      `/patient/${id}/clinical-services/${serviceId}/form/${form.type}`
                                    );
                                  }
                                }}
                              >
                                <span className={`${form?.enable ? "" : "opacity-60"}`}>{form.name}</span>
                                {(form.isTooltip && !isStoryboard) || PrimaryProviderRuleTooltipsSelected[form.type] || PrimaryProviderRuleTooltipsDisabled[form.type] ? (
                                  <>
                                    <ReactSVG
                                      src="/icons/information-dark.svg"
                                      className="w-5 pointer-events-auto"
                                      data-tooltip-id={tooltipId}
                                    />
                                    <NewToolTip
                                      id={tooltipId}
                                      offset={0}
                                      render={() => {
                                        if (form.tooltipComponent) return <form.tooltipComponent />;
                                        const text = form.enable ? PrimaryProviderRuleTooltipsSelected[form.type]
                                          : PrimaryProviderRuleTooltipsDisabled[form.type] || PrimaryProviderRuleTooltipsSelected[form.type];
                                        return (
                                          <div className="bg-gray-10 p-2 flex flex-col max-w-[281px]">
                                            <p className="text-teal-300 text-sm font-normal">{text}</p>
                                          </div>
                                        );
                                      }}
                                    />
                                  </>
                                ) : null}
                                {form.isTooltip && isStoryboard && (
                                  <NewToolTip
                                    id={tooltipId}
                                    offset ={-14}
                                    render={() => (
                                      <div className="bg-gray-10 p-2 flex flex-col max-w-[281px]">
                                        <p className="text-teal-300 text-sm font-normal">
                                          Storyboard Coming Soon
                                        </p>
                                      </div>
                                    )}
                                  />
                                )}
                                {isDisabledPersonalMedRecord && (
                                  <NewToolTip
                                    id={tooltipId}
                                    offset={-14}
                                    render={() => (
                                      <div className="bg-white p-2 flex flex-col max-w-[300px] items-start">
                                        <p className="text-gray-800 text-sm font-normal text-left">
                                          Resolve existing interventions before sharing the Personal Medication Record.
                                          <br />
                                          Resolve under "Intervention Management".
                                        </p>
                                      </div>
                                    )}
                                  />
                                )}
                              </button>
                              <div className="border-b-2 border-gray-100"></div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ImageModal image={image} setImage={setImage} />
      {filePath ? (
        <OldPdfDialog
          open={showPdfViewer}
          title={pdfTitle}
          fileUrl={filePath}
          onClose={() => {
            document.body.style.overflow = "auto";
            setShowPdfViewer(false);
          }}
          smallSize={true}
        />
      ) : (
        <PdfDialog
          open={showPdfViewer}
          component={handlePdfRender}
          onClose={() => {
            document.body.style.overflow = "auto";
            setShowPdfViewer(false);
          }}
          title={pdfTitle}
          fileUrl={filePath}
        />
      )}
      <ConfirmationModalNew
        open={openServiceCompleteDialog}
        titleClassName="text-[22px]"
        title={
          clinicalServiceName === ClinicalServiceTypes.AllergicRhinitis
            ? "Minor Ailment Service Complete"
            : "Annual Medication Review Complete"
        }
        content={() => (
          <div className="flex flex-col gap-4">
            <p className="!text-[18px] font-semibold text-body-md text-gray-600">
              Forms have been [printed /emailed / faxed]
            </p>
            <p className="!text-[16px] font-normal text-body-sm text-gray-600">
              Documentation will be saved in the Patient Chart under Medical
              Summary
            </p>
          </div>
        )}
        handleClose={() => setOpenServiceCompleteDialog(false)}
        cancelAction={() => setOpenServiceCompleteDialog(false)}
        confirmAction={async () => {
          await onSubmit();
        }}
        confirmText="Continue"
        cancelText="Cancel"
        type="primary"
        cancelBtnType="primary-outline"
      />
      <div className="flex items-center justify-between space-x-4 rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
            }}
          />
          <Button
            type="primary"
            text="Service Complete"
            className={`w-[200px] max-h-[52px] !rounded-[30px] `}
            onClick={() => {
              // Show EndServiceModel for both services
              setOpenServiceCompleteDialog(true);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Documentations;
